function naturalSort<T>(arr: Array<T>): Array<T> {
    return arr.sort((a, b) => {
        const aParts = String(a ?? '').match(/(\d+|\D+)/g) || []
        const bParts = String(b ?? '').match(/(\d+|\D+)/g) || []

        for (let i = 0; i < Math.min(aParts.length, bParts.length); i++) {
            const aPart = aParts[i]
            const bPart = bParts[i]

            if (aPart !== bPart) {
                const aIsNumber = !isNaN(Number(aPart))
                const bIsNumber = !isNaN(Number(bPart))

                if (aIsNumber && bIsNumber) {
                    return Number(aPart) - Number(bPart)
                } else if (aIsNumber) {
                    return -1
                } else if (bIsNumber) {
                    return 1
                } else {
                    return aPart.localeCompare(bPart, undefined, {
                        sensitivity: 'base' // ignores case AND accents (diacritics)
                    })
                }
            }
        }

        return aParts.length - bParts.length // If all parts are equal, sort by length
    })
}

export default naturalSort
